import { staticText } from "../../../statics/static-text";

// TEXT
const text = staticText.form.navigationGuard;

// STYLES

// DATA

// TYPES
export type NavigationGuardConfig = {
  enabled?: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
};

// CONSTANTS
export const defaultNavigationGuardConfig: Required<NavigationGuardConfig> = {
  enabled: true,
  title: text.title,
  message: text.message,
  confirmText: text.confirmText,
  cancelText: text.cancelText,
};

// FUNCTIONS

// ASSETS
